"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_http_1 = require("@blockpass-org/utils-http");
const v1_1 = __importDefault(require("./v1"));
const v2_1 = __importDefault(require("./v2"));
const ServiceManagement_1 = __importDefault(require("./ServiceManagement"));
const MerchantProfile_1 = __importDefault(require("./MerchantProfile"));
const ServiceWebhook_1 = __importDefault(require("./ServiceWebhook"));
const ServiceDisplay_1 = __importDefault(require("./ServiceDisplay"));
const ServiceAPIKey_1 = __importDefault(require("./ServiceAPIKey"));
const ServiceMember_1 = __importDefault(require("./ServiceMember"));
const RuntimeConfig_1 = __importDefault(require("./RuntimeConfig"));
const ActivityLog_1 = __importDefault(require("./ActivityLog"));
const Uploader_1 = __importDefault(require("./Uploader"));
const MailSubscription_1 = __importDefault(require("./MailSubscription"));
const Company_1 = __importDefault(require("./Company"));
const Usage_1 = __importDefault(require("./Usage"));
const ServiceBilling_1 = __importDefault(require("./ServiceBilling"));
const Plan_1 = __importDefault(require("./Plan"));
const KYBServiceManagement_1 = __importDefault(require("./KYBServiceManagement"));
const KYBServiceMember_1 = __importDefault(require("./KYBServiceMember"));
const AdminTool_1 = __importDefault(require("./AdminTool"));
const ServiceEncryptionKey_1 = __importDefault(require("./ServiceEncryptionKey"));
const VERSION = '1.0.0';
/**
 * Admin Console Client class is the main class of this package.
 * This class is used to init an client
 * @public
 */
class AdminConsoleClient {
    constructor(session, env, bpService) {
        switch (env) {
            case 'qa': {
                this._gateWayHost = 'https://qa-mapi.blockpass.org';
                this._acHost = 'https://qa-old-console.blockpass.org';
                break;
            }
            case 'staging': {
                this._gateWayHost = 'https://sandbox-mapi.blockpass.org';
                this._acHost = 'https://sandbox-old-console.blockpass.org';
                break;
            }
            case 'prod': {
                this._gateWayHost = 'https://mapi.blockpass.org';
                this._acHost = 'https://old-console.blockpass.org';
                break;
            }
            default: {
                this._gateWayHost = 'http://localhost:3030';
                this._acHost = 'http://localhost:3000';
                break;
            }
        }
        this._bpService = bpService || utils_http_1.BLOCKPASS_SERVICE.ac;
        this._httpClient = new utils_http_1.HttpClient(this._bpService, 'web', VERSION);
        this._httpClient.setBaseUrl(this._gateWayHost);
        this._httpClient.setAuthSession(session, false);
        const _apiV1 = new v1_1.default(this._httpClient, {
            baseURL: this._acHost,
        });
        const _apiV2 = new v2_1.default(this._httpClient);
        this.serviceManagement = new ServiceManagement_1.default(_apiV1, _apiV2);
        this.merchantProfile = new MerchantProfile_1.default(_apiV1, _apiV2);
        this.serviceDisplay = new ServiceDisplay_1.default(_apiV1, _apiV2);
        this.serviceWebhook = new ServiceWebhook_1.default(_apiV1, _apiV2);
        this.serviceAPIKey = new ServiceAPIKey_1.default(_apiV1, _apiV2);
        this.serviceMember = new ServiceMember_1.default(_apiV1, _apiV2);
        this.runtimeConfig = new RuntimeConfig_1.default(_apiV1, _apiV2);
        this.activityLog = new ActivityLog_1.default(_apiV1, _apiV2);
        this.uploader = new Uploader_1.default(_apiV1, _apiV2);
        this.mailSubscription = new MailSubscription_1.default(_apiV1, _apiV2);
        this.company = new Company_1.default(_apiV1, _apiV2);
        this.usage = new Usage_1.default(_apiV1, _apiV2);
        this.serviceBilling = new ServiceBilling_1.default(_apiV1, _apiV2);
        this.plan = new Plan_1.default(_apiV1, _apiV2);
        this.kybServiceManagement = new KYBServiceManagement_1.default(_apiV1, _apiV2);
        this.kybServiceMember = new KYBServiceMember_1.default(_apiV1, _apiV2);
        this.adminTool = new AdminTool_1.default(_apiV1, _apiV2);
        this.serviceEncryptionKey = new ServiceEncryptionKey_1.default(_apiV1, _apiV2);
    }
}
exports.default = AdminConsoleClient;
